// @flow
export const RECEIVED_SERVER_ERRORS = 'RECEIVED_SERVER_ERRORS';
export const FORM_INITIALIZE = 'redux-form/INITIALIZE';
export const GET_CONTACTS = 'hive/text-control/GET_CONTACTS';
export const RECEIVED_CONTACTS = 'hive/text-control/RECEIVED_CONTACTS';
export const SAVE_CONTACTS = 'hive/text-control/SAVE_CONTACTS';
export const SAVED_CONTACTS = 'hive/text-control/SAVED_CONTACTS';



// WEBPACK FOOTER //
// ./src/core/state/text-control/constants.js